import React from 'react';
import RecommendProductDetailInfo from '../RecommendProductDetailInfo';
import RecommendProductDetailItemList from '../RecommendProductDetailItemList';
import './RecommendProductDetailWrap.scss';

const RecommendProductDetailWrap = (props) => {
  const { recommendProductDetail, getProductSubCategoryList, pagination, getList, getExcelDownload } = props;
  const { recommendProductInfo, recommendProductItemList, totalCnt } = recommendProductDetail;

  return (
    <div className="recommend-product-detail-wrap">
      {/* 추천 상품 정보 */}
      <RecommendProductDetailInfo recommendProductInfo={recommendProductInfo} />

      {/* 추천 상품 아이템 리스트*/}
      <RecommendProductDetailItemList
        recommendProductItemList={recommendProductItemList}
        getProductSubCategoryList={getProductSubCategoryList}
        getExcelDownload={getExcelDownload}
        totalCnt={totalCnt}
        pagination={pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendProductDetailWrap;
